'use strict';

var Marionette = require('backbone.marionette');
var $ = require('jquery');
var LocationView = require('./list-item').default;
var LocationSelectionEvents = require('../../../analytics/location-selection-events').default;

export default Marionette.CollectionView.extend({

  tagName: 'ul',
  className: 'locations-list',
  childView: LocationView,
  childViewOptions: function(model) {
    const waitTime = this.waitTimes.get(model.id);

    if (this.collection.length && this.collection.latitude && this.collection.longitude && !model.get('virtual')) {
      return {
        distance: model.distanceFromPoint(this.collection.latitude, this.collection.longitude),
        isMobile: this.isMobile,
        waitTime,
        isShowWaitTimeOn: this.showWaitTime,
      };
    }
    return {
      distance: null,
      isMobile: this.isMobile,
      waitTime,
      isShowWaitTimeOn: this.showWaitTime,
    };
  },
  events: {
    'click .locations-list-location': 'onClickLocation',
    'click .locations-list-info': 'onClickLocationInfo',
  },

  initialize: function (options) {
    this.appointment = options.appointment;
    this.location = null;
    this.isMobile = options.isMobile;
    this.waitTimes = options.waitTimes;
    this.showWaitTime = this.isShowWaitTimeOn();

    this.listenTo(this.collection, 'sort', this.render);
  },

  isEmpty: function (collection) {
    if (this.appointment.isPrivate()) {
      return true;
    }

    return Marionette.CollectionView.prototype.isEmpty.call(this, collection);
  },

  onRender: function () {
    this.selectLocation();
  },

  onClickLocation: function (evt) {
    evt.preventDefault();
    let $el = $(evt.currentTarget).parent();
    let model = this.collection.get($el.data('id'));
    if (!model) return;

    LocationSelectionEvents.trackClick('List');
    this.trigger('change:location', model);
    model.fromMapView = false;
    this.trigger('showLocationDetails', model);
  },

  onClickLocationInfo: function (evt) {
    evt.preventDefault();
    let $el = $(evt.currentTarget).parent().parent();
    let location = this.collection.get($el.data('id'));
    if (!location) return;

    LocationSelectionEvents.trackClick('List');
    location.fromMapView = false;
    this.trigger('showLocationDetails', location);
  },

  setLocation: function (location) {
    this.location = location;
    this.selectLocation();
  },

  selectLocation: function () {
    if (this.isEmpty()) {
      return;
    }

    let self = this;
    this.children.each(function (child) {
      if (self.location && child.model.id == self.location.id) {
        child.select();
      } else {
        child.deselect();
      }
    });
  },

  isShowWaitTimeOn: function () {
    return window.SETTINGS.show_wait_time
      && this.appointment.isDisplayInLobbyEnabled()
      && this.appointment.get('service_id').length === 1
      && !this.appointment.isGroup()
      && !this.appointment.get('staff_id');
  },
});
